import { CREDIT_LINE_REQUEST_STATUS_MAP } from 'lib/consts';

import type { StatusChipType } from '../index';

type CreditLineStatusKey = keyof typeof CREDIT_LINE_REQUEST_STATUS_MAP;

const CREDIT_LINE_STATUS_CHIP_MAP: Record<CreditLineStatusKey, StatusChipType> =
  {
    NOT_REQUESTED: 'default',
    VALIDATING: 'warning',
    REVIEWED: 'reviewed',
    ASSIGNED: 'assigned',
    ACTIVE: 'success',
    REJECTED: 'error',
    FROZEN: 'warning',
    DUE: 'due',
  };

const LABEL_TO_KEY = Object.fromEntries(
  Object.entries(CREDIT_LINE_REQUEST_STATUS_MAP).map(([k, v]) => [v, k]),
) as Record<string, CreditLineStatusKey>;

export const getCreditLineStatusLabel = (statusOrKey: string): string => {
  if (statusOrKey in CREDIT_LINE_REQUEST_STATUS_MAP) {
    return CREDIT_LINE_REQUEST_STATUS_MAP[statusOrKey as CreditLineStatusKey];
  }
  return statusOrKey;
};

export const getCreditLineStatusChipType = (
  statusOrLabel: string,
): StatusChipType => {
  const key =
    statusOrLabel in CREDIT_LINE_REQUEST_STATUS_MAP
      ? (statusOrLabel as CreditLineStatusKey)
      : LABEL_TO_KEY[statusOrLabel];
  return (key && CREDIT_LINE_STATUS_CHIP_MAP[key]) ?? 'default';
};
